// IndonesiaCompanyRegistration.jsx
import React from "react";

export default function IndonesiaCompanyRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Indonesia Company Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists with Indonesia Company Registration in compliance with local investment regulations.
          </p>
          <p className="text-gray-700">
            Complete PT PMA incorporation through OSS system including Deed of Establishment notarization, NIB issuance, KBLI classification, Ministry of Law approval, and NPWP tax registration.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: Indonesia business incorporation and OSS compliance) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/116675/pexels-photo-116675.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Indonesia company registration and OSS compliance"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation preparation for seamless OSS and Ministry approvals.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Passport copies (shareholders, directors, commissioners)</li>
                <li>Business activity details (KBLI codes and company scope)</li>
                <li>Address proof (office lease or virtual office agreement)</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Proven expertise in PT PMA registrations across Jakarta, Surabaya, and Bali with comprehensive OSS-RBA compliance solutions.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Indonesian Regulatory Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete OSS system knowledge including PT PMA requirements, KBLI classification, minimum IDR 10 billion capital rules, 2 Indonesian commissioners, and BKPM investment approvals.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Documentation Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise Deed of Establishment preparation, notary coordination, MOLHR submissions, OSS-NIB applications, domicile letters, and multi-language document translation ensuring first-time approvals.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable Professional Service
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end service from OSS account setup through NIB issuance, NPWP registration, KITAS visa processing, office solutions, bank account opening, and first-year compliance advisory.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
